// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bnz0Cp9L67haQ_ {
  max-width: 240px;
}
@media only screen and (min-width: 751px) and (max-width: 900px), only screen and (max-width: 750px), only screen and (max-width: 600px) {
  .bnz0Cp9L67haQ_ {
    max-width: 100%;
    margin-bottom: 10px;
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"searchWrapper": `bnz0Cp9L67haQ_`
};
export default ___CSS_LOADER_EXPORT___;
